import { memo } from 'react';
// import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg'
import {
  ClipPath as _ClipPath,
  Defs as _Defs,
  G as _G,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg,
} from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      width={size}
      height={size}
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_G clipPath="url(#clip0_3102_56368)">
        <_Path
          d="M2.17207 20.1033H9.87539V40.6718H2.17535C1.96165 40.6723 1.74996 40.6304 1.55241 40.5487C1.35485 40.467 1.1753 40.3471 1.02404 40.1957C0.872782 40.0443 0.752777 39.8645 0.670899 39.6666C0.58902 39.4686 0.546875 39.2564 0.546875 39.0421V21.733C0.546875 21.3008 0.718101 20.8862 1.02288 20.5806C1.32767 20.275 1.74105 20.1033 2.17207 20.1033Z"
          fill="#368665"
        />
        <_Path
          d="M11.8711 20.1033L20.1282 6.86842C20.4481 6.34496 20.898 5.91362 21.4338 5.61648C21.9695 5.31933 22.573 5.16653 23.1852 5.17299C23.6666 5.15586 24.1465 5.23557 24.5967 5.40742C25.0469 5.57927 25.4581 5.83978 25.8063 6.17358C26.1544 6.50738 26.4324 6.90772 26.6238 7.35097C26.8151 7.79423 26.9161 8.27143 26.9206 8.75442V18.2403H41.1935C41.721 18.2571 42.239 18.3858 42.7133 18.6179C43.1876 18.85 43.6075 19.1803 43.9453 19.587C44.283 19.9937 44.531 20.4676 44.6729 20.9773C44.8147 21.4871 44.8473 22.0213 44.7683 22.5446L42.1699 39.3641C42.0589 40.2629 41.6244 41.0902 40.9481 41.6904C40.2717 42.2906 39.4 42.6224 38.4968 42.6236H17.1694C16.1536 42.6268 15.1543 42.3936 14.2466 41.9401L11.9039 40.7671M11.8711 20.1033V40.6718V20.1033Z"
          fill="#368665"
        />
      </_G>
      <_Defs>
        <_ClipPath id="clip0_3102_56368">
          <_Rect width="45.8726" height="46" fill="white" transform="translate(0.75)" />
        </_ClipPath>
      </_Defs>
    </_Svg>
  );
};
Icon.displayName = 'HelpFullSolid';
const HelpFullSolid = memo(themed(Icon));
export { HelpFullSolid };
